import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  TemplateRef,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  GotoQuestionAction,
  InteractionQuestion,
} from '../../../../../models/interactions.model';

@Component({
  selector: 'app-goto-question-action',
  imports: [MatIcon, CdkDragHandle, NgTemplateOutlet],
  templateUrl: './goto-question-action.component.html',
  styleUrl: './goto-question-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GotoQuestionActionComponent {
  public readonly data = input.required<GotoQuestionAction>();
  public readonly questions = input<InteractionQuestion[]>([]);
  public readonly actions = input<TemplateRef<unknown>>();

  protected readonly actualData = computed(() => {
    const question = this.questions().find(
      (question) => question._id === this.data().value
    );

    if (!question) {
      return null;
    }

    return {
      ...this.data(),
      value: { ...question },
    };
  });
}
